import React from 'react'
import { Section, Image, Link } from 'newComponents'
import { ReactComponent as Stars } from '../../../images/home/quote-stars.svg'
import { ReactComponent as LeftStars } from '../../../images/home/quote-stars-left.svg'
import { ReactComponent as RightStars } from '../../../images/home/quote-stars-right.svg'
import './styles.scss'

const HomeQuote = (props) => {
  const { photo, logo, title, content, link } = props

  const hasPhoto = photo?.localFile || photo.url
  const logoUrl = logo?.url
  const titleText = title?.text
  const contentHtml = content?.html

  return (
    <Section className="home-quote">
      <Stars className="home-quote-stars" />
      <LeftStars className="home-quote-left-stars" />
      <RightStars className="home-quote-right-stars" />
      <div className="home-quote-container">
        {hasPhoto && (
          <div className="home-quote-image">
            <Image image={photo} />
          </div>
        )}
        <div className="home-quote-body">
          <Image image={logoUrl} className="home-quote-body-logo" />
          <span className="home-quote-body-title">{titleText}</span>
          <div className="home-quote-body-content" dangerouslySetInnerHTML={{ __html: contentHtml }} />
          {link && <Link className="home-quote-body-link" to={link?.to} withChevron>
            {link?.text}
          </Link>}
        </div>
      </div>
    </Section>
  )
}

export default HomeQuote
